import { RouterProvider } from '@tanstack/react-router';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

import { router } from './router';
import './App.css';
import { launchDarklyConfig } from '@api/auth/config';
import { getAnonId } from '@utils/anonymousId';

const App = () => {
  return <RouterProvider router={router} />;
};

export default withLDProvider({
  options: {
    logger: {
      debug: () => {},
      info: () => {},
      warn: () => {},
      error: () => {},
    },
  },
  clientSideID: launchDarklyConfig.clientId ?? '',
  user: {
    key: getAnonId(),
    anonymous: true,
  },
})(App);
